// Template254: Bélgica - Día 4 Brujas (Page12.jsx)
// Hero portada + título Brujas + sticker, intro, caja transporte, Grote Markt, Campanario, Canales, caja calles.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template254 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const intro = page?.texts?.[1]?.content;
	const tipTransporte = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[5]?.content;
	const block2Body = page?.texts?.[6]?.content;
	const block3Title = page?.texts?.[7]?.content;
	const block3Body = page?.texts?.[8]?.content;
	const cajaCalles = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img1 = getImageSrc("img1");
	const img2 = getImageSrc("img2");
	const img3 = getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#D4A017";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "14px",
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				<Box
					component="h1"
					sx={{
						fontSize: isSmallScreen ? 28 : 32,
						textAlign: "center",
						position: "absolute",
						bottom: 0,
						margin: "10px",
						left: 20,
						color: "#fff",
						textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						fontWeight: 700,
					}}
				>
					Brujas
				</Box>
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 100, position: "absolute", bottom: 60, left: 20 }}
					/>
				)}
			</Box>

			<Box
				data-block-id="text-1"
				sx={{
					padding: "10px 12px",
					paddingBottom: "5px",
					position: "relative",
				}}
			>
				{intro && (
					<Box
						component="p"
						sx={{
							fontSize: 13,
							color: "#333",
							margin: 0,
							padding: 0,
							marginTop: "-7px",
						}}
					>
						{intro}
					</Box>
				)}

				{tipTransporte && (
					<Box
						sx={{
							backgroundColor: "#fef9e6",
							border: "2px solid #D4A017",
							borderRadius: "12px",
							padding: "8px 16px",
							fontSize: "13px",
							color: "#444",
							textAlign: "center",
							marginBottom: "6px",
							marginTop: "4px",
						}}
					>
						<Box component="p" sx={estiloP}>
							{tipTransporte}
						</Box>
					</Box>
				)}

				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 1,
						marginTop: "6px",
					}}
				>
					{/* Grote Markt */}
					{(block1Title || block1Body) && (
						<Box sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img1 && (
								<Box
									component="img"
									src={img1}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[0] && (
								<Box sx={{ position: "absolute", top: 10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[0].icono}
										texto={sabiasQue[0].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%", position: "relative" }}>
								{block1Title && (
									<Box component="h3" sx={estiloH3}>
										{block1Title}
									</Box>
								)}
								{block1Body && (
									<Box component="p" sx={{ ...estiloP, fontSize: 13 }}>
										{block1Body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Campanario */}
					{(block2Title || block2Body) && (
						<Box sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img2 && (
								<Box
									component="img"
									src={img2}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[1] && (
								<Box sx={{ position: "absolute", top: 30, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[1].icono}
										texto={sabiasQue[1].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{block2Title && (
									<Box component="h3" sx={estiloH3}>
										{block2Title}
									</Box>
								)}
								{block2Body && (
									<Box component="p" sx={estiloP}>
										{block2Body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{/* Canales */}
					{(block3Title || block3Body) && (
						<Box sx={{ display: "flex", gap: 2, position: "relative" }}>
							{img3 && (
								<Box
									component="img"
									src={img3}
									alt=""
									sx={{
										width: "40%",
										height: 110,
										objectFit: "cover",
										borderRadius: "12px",
									}}
								/>
							)}
							{sabiasQue[2] && (
								<Box sx={{ position: "absolute", top: -10, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[2].icono}
										texto={sabiasQue[2].texto}
									/>
								</Box>
							)}
							<Box sx={{ width: "60%" }}>
								{block3Title && (
									<Box component="h3" sx={estiloH3}>
										{block3Title}
									</Box>
								)}
								{block3Body && (
									<Box component="p" sx={estiloP}>
										{block3Body}
									</Box>
								)}
							</Box>
						</Box>
					)}

					{cajaCalles && (
						<Box
							sx={{
								backgroundColor: "#fef9e6",
								border: "2px solid #D4A017",
								borderRadius: "12px",
								padding: "4px 16px",
								fontSize: "13px",
								color: "#444",
								textAlign: "center",
							}}
						>
							<Box component="p" sx={estiloP}>
								{cajaCalles}
							</Box>
						</Box>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template254.thumbnail = "/images/template-1.png";
export default Template254;
